var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.icon
    ? _c("img", {
        staticClass: "icon",
        attrs: {
          src: require(`../../assets/icons/i_${_vm.icon}.svg`),
          alt: "image description",
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }